module.exports = __webpack_public_path__ + "static/newmomentsmain-76e2864fa73a10fac69125e3b14cf3fb.png";